import {
    axiosSetHideorUnhide,
    axiosDeletePageOrPost,
    axiosSetToHome,
    axiosSetDuplicate,
    axiosRenamePageAndPost,
    axiosSaveSettingBacktotop,
    axiosAddPage,
} from '../../api/admin/default';

window.activePageID;
window.activePageName;
window.activeSlug;
window.activeSlugID;
window.activePageType;
window.activeId, window.eleActive;
window.currentPageData = {};
window.initPageOption = false;
window.currentPageID;
window.currentSlugID;
window.currentPageType;
window.activeType;
window.activeBlogId;
window.activeBlogname;
window.activeIndexKey;
window.blogindex;

import * as customIconJStree from '../../global/jstreeiconstatus';

(function ($) {
    RVwys.plugin['Rightbar'] = true;
    RVwys.rigthbar = {};
    RVwys.rigthbar.isJstree = {};
    RVwys.rigthbar.isJstree.page = {};
    RVwys.rigthbar.isJstree.blog = {};

    $(document).bind('editorReady', function () {
        // Pagebar
        var fb = $('#frameBody').get(0).contentWindow;
        var pageMetatag, pageCss, pageJs, sidebarStyle;
        // Get Current Page Option
        if (typeof parent.currentPageJSON != 'undefined') {
            var dataPas = parent.currentPageJSON;
            const iconVisibility = {
                ...customIconJStree.JStreeTypeIconPage(),
                ...customIconJStree.JStreeTypeIconBlog(),
                ...customIconJStree.JStreeTypeIconSystem(),
                ...customIconJStree.JStreeTypeIconHome(),
            };

            $('#CurrenttypeIcon').addClass(iconVisibility[dataPas.type].icon);

            if (dataPas.statusIcon.match(/draft/)) {
                $('#CurrenttypeIcon')
                    .closest('.sprite-icon-visibility')
                    .css('opacity', '0.5');
            }

            parent.currentPageID = dataPas.id;
            parent.activePageID = dataPas.id;
            parent.activePageName = dataPas.page_name;
            parent.activeSlug = dataPas.slug.slug_name;
            parent.currentSlugID = dataPas.slug_id;
            parent.currentPageType = dataPas.slug_type;

            $('.current-optionPage').attr('page-id', dataPas.id);
            $('.current-optionPage').attr('page-slug', dataPas.slug.slug_name);
            $('.current-optionPage').attr('page-name', dataPas.page_name);
            $('.current-optionPage').attr('is-pulbic', dataPas.is_published);
            $('.current-optionPage').attr('is-homepage', dataPas.is_homepage);
            $('.current-optionPage').attr('slug-id', dataPas.slug_id);
            $('.current-optionPage').attr('type', dataPas.type);

            //					$('#CurrentType').text(dataPas.slug_type);
        }

        console.log($('.current-optionPage'));

        $('.current-optionPage').click(function () {
            RVwys.hidePanelAll();
            parent.activePageID = $('.current-optionPage').attr('page-id');
            parent.activePageName = $('.current-optionPage').attr('page-name');
            parent.activeSlug = $('.current-optionPage').attr('page-slug');

            var type = currentPageType == 'Category' ? true : false;
            var isTypeSystem = $('.current-optionPage')
                .attr('type')
                .match('system');

            $('.pageSetting,.wys-rowTwo').hide();
            $('.bar-right,.bar-category').addClass('bar-category-hidden');
            //alert('sss')
            $('.rvsb-design-property').hide();
            $('.current-pageSetting').css({
                right: '50px',
                top: '120px',
            });
            var $this = $(this);
            var isPublic = $this.attr('is-pulbic') == 1 ? true : false;
            var isHomepage =
                $this.attr('is-homepage') === 'true' ? true : false;

            $('#currentUnsetHide').toggle(!isPublic);
            $('#currentSetHide').toggle(isPublic);

            if (isPublic) {
                switch (currentPageType.toLowerCase()) {
                    case 'system':
                        $('#currentRenamePage').toggle(isHomepage);
                        $('#currentSetHide').toggle(isHomepage);
                        $('#currentSetHomePage').toggle(isHomepage);
                        $('#currentSetHide').toggle(type);
                        $('#currentDuplicate').toggle(type);

                        $('#currentUnsetHide').hide();

                        var blogIndex =
                            parent.activeSlug == 'blog' ? true : false;

                        $('#currentVisibility').toggle(blogIndex);

                        break;
                    case 'post':
                    case 'page':
                    case 'category':
                        $('#currentSetHomePage').toggle(!isHomepage);
                        $('#currentDuplicate').toggle(!type);

                        if (isTypeSystem) {
                            $('#currentRenamePage').toggle(isHomepage);
                            $('#currentSetHide').toggle(isHomepage);
                            $('#currentSetHomePage').toggle(isHomepage);
                            $('#currentSetHide').toggle(type);
                            $('#currentDuplicate').toggle(type);

                            $('#currentVisibility').hide();
                        }
                        $('#currentUnsetHide').hide();
                        break;
                    default:
                        break;
                }
            }
        });

        // Start Active Category Section name
        $('.rvsb-design-bar-right .rightmenu-icon').click(function () {
            $('.rightmenu-icon').removeClass('active-site');
            $(this).addClass('active-site');
            console.log($(this).parent().find('.rightmenu-icon').length);
        });
        // End Active Site Section name

        // addPage
        fb.$('.addPage').click(function () {
            RVwys.addPageModal();
        });

        $('#currentUnsetHide,#currentSetHide').click(function () {
            const checkStatus =
                $(this).attr('id') == 'currentSetHide'
                    ? { public: '0', opacity: '0.5' }
                    : { public: '1', opacity: '' };

            console.log('$(this): ', $(this));
            axiosSetHideorUnhide({
                slug_id: parent.currentSlugID,
            }).then(result => {
                $('.current-optionPage').attr('is-pulbic', checkStatus.public);
                $('.current-optionPage').trigger('click');

                var elemLi = fb.$(
                    `.liListPage[slug-id="${parent.currentSlugID}"],.liListPost[slug-id="${parent.currentSlugID}"]`
                );
                elemLi.find('.editPage').attr('is-pulbic', checkStatus.public);
                elemLi
                    .find('.editPageWithPageName')
                    .css('opacity', checkStatus.opacity);
            });
        });

        var editviewRename = $('#editviewRename').html();

        $('#currentRenamePage').click(function () {
            var beforeSlug = parent.activeSlug;

            var UI = UIkit;
            var onInsert = function () {
                axiosRenamePageAndPost({
                    page_name: modal.element.find('#pageName').val().trim(),
                    slug_id: parent.currentSlugID,
                })
                    .then(resposnse => {
                        var afterSlug = resposnse.data.data.slug_name;
                        var typepage =
                            parent.currentPageType != 'Page'
                                ? 'blog'
                                : parent.currentPageType.toLowerCase();

                        parent.activePageName = resposnse.data.data.page_name;

                        $('#cmsCurrent').text(resposnse.data.data.page_name);
                        $('.current-optionPage').attr(
                            'page-name',
                            resposnse.data.data.page_name
                        );

                        var oLi = fb.$(
                            '.liListPage[slug-id=' + parent.currentSlugID + ']'
                        );
                        oLi.find('.editPage').attr(
                            'page-name',
                            resposnse.data.data.page_name
                        );
                        oLi.find('.editPageWithPageName').text(
                            resposnse.data.data.page_name
                        );

                        if (resposnse.data.data.changed_menutitle) {
                            RVwys.rigthbar.isJstree.updatemenu(
                                beforeSlug,
                                resposnse.data.data
                            );
                        }
                        //
                        if (afterSlug != beforeSlug) {
                            window.history.pushState(
                                'data',
                                'Title',
                                resposnse.data.data.url
                            );

                            var objpage = {
                                page: {},
                                blog: {},
                            };
                            objpage.page.type = {
                                page_onmenu: '',
                                page_internal: '',
                            };

                            if (parent.currentPageType == 'Post') {
                                objpage.blog.type = {
                                    blog_lists: '',
                                    blog_recently: '',
                                };
                            } else {
                                objpage.blog.type = {
                                    blog_categories: '',
                                    blog_listscategory: '',
                                };
                            }

                            var slug = parseInt(resposnse.data.data.slug_id);
                            var nameNew = resposnse.data.data.page_name;

                            $.each(objpage[typepage].type, function (type) {
                                var indexWex = $.map(
                                    parent.wex[typepage][type],
                                    function (obj) {
                                        return obj.slug_id;
                                    }
                                ).indexOf(slug);

                                if (indexWex != -1) {
                                    switch (parent.currentPageType) {
                                        case 'Post':
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].page_name = nameNew;
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].slug_name =
                                                resposnse.data.data.slug_name;
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].text = nameNew;

                                            break;
                                        case 'Category':
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].slug_name =
                                                resposnse.data.data.slug_name;
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].text = nameNew;

                                            // Update blog_lists
                                            $.each(
                                                parent.wex.blog.blog_lists,
                                                function (k, obj) {
                                                    if (
                                                        obj.category_name ==
                                                        window.activeBlogname
                                                    ) {
                                                        parent.wex.blog.blog_lists[
                                                            k
                                                        ].category_name = nameNew;
                                                        parent.wex.blog.blog_lists[
                                                            k
                                                        ].slug_prefix =
                                                            resposnse.data.data.slug_prefix;
                                                    }
                                                }
                                            );

                                            break;

                                        default:
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].page_name =
                                                resposnse.data.data.page_name;
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].slug_name =
                                                resposnse.data.data.slug_name;
                                            parent.wex[typepage][type][
                                                indexWex
                                            ].text =
                                                resposnse.data.data.page_name;

                                            break;
                                    }
                                }
                            });
                        }

                        modal.hide();
                        console.pop.success({
                            text: resposnse.data.data.message,
                            delay: 5000,
                        });
                    })
                    .catch(err => {
                        console.pop.error({
                            text: err.data.data.message,
                        });
                    });
            };

            oncancel = function () {
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Rename') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewRename +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
            makeSlug(modal.element);
        });

        $('#currentSetHomePage').click(function () {
            console.log(
                'Event click #currentSetHomePage: ',
                $('#currentSetHomePage')
            );

            $('.current-pageSetting').hide();

            axiosSetToHome({ slug_id: parent.currentSlugID }).then(result => {
                $('#CurrenttypeIcon')
                    .removeAttr('class')
                    .addClass('icon-visibility home-normal');
                $('.current-optionPage').attr('is-homepage', '1');

                //  TODO:WEX remove after make route wex API
                // Start
                var typebar = currentPageType.toLowerCase();

                var indexHome = $.map(parent.wex[typebar]['page_tree'], obj => {
                    return obj.is_homepage;
                }).indexOf(1);

                if (indexHome != -1) {
                    parent.wex[typebar]['page_tree'][indexHome].is_homepage = 0;
                    parent.wex[typebar]['page_tree'][indexHome].type =
                        'default';
                }

                var newHome = $.map(parent.wex[typebar]['page_tree'], obj => {
                    return obj.text;
                }).indexOf(parent.activePageName);

                if (newHome != -1) {
                    parent.wex[typebar]['page_tree'][newHome].is_homepage = 1;
                    parent.wex[typebar]['page_tree'][newHome].type = 'home';
                }

                // End
            });
        });

        $('#currentDuplicate').click(function () {
            fb.$('.pageSetting').hide();
            console.log('Deuplicate page : ' + parent.activePageName);

            fb.$('.bar-page').addClass('bar-category-hidden');
            fb.$('.bar-right').hide();

            var overlaypanel = $(
                `<div class="overlaypanel">
                    <img class="loading" src="{parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
                </div>`
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });

            parent.$('body').append(overlaypanel);

            axiosSetDuplicate({ slug_id: parent.currentSlugID })
                .then(resposnse => {
                    setTimeout(function () {
                        parent.$('.overlaypanel').remove();
                        window.location.href = resposnse.data.data.url;
                    }, 3000);
                })
                .catch(err => {
                    console.pop.error({
                        text: err.data.data.message,
                    });
                    parent.$('.overlaypanel').remove();
                });
        });

        // postbar

        // AddPost
        // START add post
        fb.$('.addPost').click(function () {
            RVwys.addPostModal();
        });
        // End Addpost
    });

    $(document).bind('designReady', function (e) {});
    // EditorReady
    $(document).bind('editorReady', function (e) {
        $('#right-bar-addpost').click(function () {
            $('#frameBody').get(0).contentWindow.$('.addPost').trigger('click');
        });
        var url = window.location.href;
        if (url.match(/\/email\/?/)) {
            $('.bar-left ').hide();
            $('.wys-email').show();
        }
        var timeout = false;
        $('#listPageSearch').keyup(function () {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                $('#listpage_onmenu').jstree(
                    'search',
                    $('#listPageSearch').val()
                );
                $('#listpage_internal').jstree(
                    'search',
                    $('#listPageSearch').val()
                );
            }, 250);
        });

        $('#listPostSearch').keyup(function () {
            if (timeout) {
                clearTimeout(timeout);
            }

            timeout = setTimeout(function () {
                $('#listblog').jstree('search', $('#listPostSearch').val());
                $('#RecentPost').jstree('deselect_all');
            }, 250);
        });

        $('#plugins4').jstree({
            plugins: ['search'],
        });

        $(`.bar-right-page a`).click(function () {
            RVwys.rigthbar.isJstree.refresh(
                $('#listpage_onmenu'),
                wex.page.page_tree,
                'page'
            );
        });

        $(`.bar-right-posts a,[onclick="bar_class('bar-post')"]`).click(
            function () {
                if (!wex.blog.blog_first) {
                    $('.bar-category-first').addClass('bar-category-hidden');
                }

                var listblog = wex.blog.blog_lists.concat(
                    wex.blog.blog_listscategory
                );
                RVwys.rigthbar.isJstree.refresh(
                    $('#listblog'),
                    listblog,
                    'blog'
                );
                // wex.blog.blog_lists

                $.each(wex.blog.blog_recently, function (k, v) {
                    wex.blog.blog_recently[k]['type'] = 'default';

                    wex.blog.blog_recently[k]['li_attr'] = {
                        'value-post': v.text,
                    };

                    wex.blog.blog_recently[k]['a_attr'] = {
                        href:
                            wex.url.WYS_SHOW_URL +
                            '/' +
                            v.slug_prefix +
                            '/' +
                            v.slug_name,
                    };
                });
                var _selectedNodeId;

                $('#RecentPost').jstree({
                    core: {
                        data: wex.blog.blog_recently,
                    },
                    types: {
                        default: {
                            icon: 'icon-visibility bpost-normal',
                        },
                    },
                    plugins: ['types', 'wholerow', 'changed'],
                });

                $('#RecentPost').bind('select_node.jstree', function (e, data) {
                    var href = data.node.a_attr.href;
                    window.location.href = href;
                });
            }
        );

        $('.bar-right-system a').click(function () {
            if ($('#listSystem li').length == '0') {
                var systempage = wex.systempage.editable_lists;
                $.each(systempage, function (k, v) {
                    if (v.typeUrl) {
                        systempage[k]['a_attr'] = {
                            href:
                                wex.url.WYS_SHOW_URL +
                                '/' +
                                v.slug_prefix +
                                '/' +
                                v.slug_name,
                        };
                    } else {
                        systempage[k]['a_attr'] = {
                            href: wex.url.WYS_SHOW_URL + '/' + v.slug_name,
                        };
                    }
                });

                var module = wex.systempage.module_lists;
                $.each(module, function (k, v) {
                    module[k]['a_attr'] = {
                        href: wex.url.WYS_SHOW_URL + '/' + v.url,
                    };
                });

                var system = wex.systempage.module_lists.concat(systempage);

                $('#listSystem')
                    .jstree({
                        core: {
                            data: system,
                            check_callback: true,
                            multiple: false,
                        },
                        types: {
                            systempage: {
                                icon: 'icon-visibility syspost-normal',
                            },
                            category: {
                                icon: 'icon-visibility bcate-normal',
                            },
                        },
                        search: {
                            case_insensitive: true,
                            show_only_matches: true,
                            // 'search_leaves_only':true
                        },
                        plugins: ['types', 'search'],
                    })
                    .on('loaded.jstree', function () {
                        $(this).jstree('open_all');
                    })
                    .on('select_node.jstree', function (e, data) {
                        var href = data.node.a_attr.href;
                        window.location.href = href;
                    });

                $('#Countsystem').text(wex.systempage.editable_lists.length);
            }
        });

        $('#listSystemSearch').keyup(function () {
            $('#listSystem').jstree('search', $(this).val());
        });

        // Pagebar
        $('#setHide,.postSetting #setHide').click(function () {
            console.log('Event: setHide ID: ' + activePageID);

            axiosSetHideorUnhide({ slug_id: activeSlugID }).then(result => {
                RVwys.rigthbar.isJstree.Callbackoption(
                    result.data,
                    'setHide',
                    activePageType
                );

                console.pop.success({
                    text: 'Set as hide ' + result.data.data.message,
                    delay: 5000,
                });
            });
        });

        $('#unsetHide,.postSetting #unsetHide').click(function () {
            console.log('set draft page : ' + activePageID);
            $('.pageSetting').hide();

            axiosSetHideorUnhide({ slug_id: activeSlugID }).then(result => {
                RVwys.rigthbar.isJstree.Callbackoption(
                    result.data,
                    'unsetHide',
                    activePageType
                );

                console.pop.success({
                    text: 'Set as unhide ' + result.data.data.message,
                    delay: 5000,
                });
            });
        });

        $('#setHomePage,.postSetting #setHomePage').click(function () {
            $('.pageSetting').hide();

            axiosSetToHome({ slug_id: activeSlugID }).then(result => {
                RVwys.rigthbar.isJstree.Callbackoption(
                    result.data,
                    'setHomePage',
                    activePageType
                );
                console.pop.success({
                    text: result.data.data.message,
                    delay: 5000,
                });
            });
        });

        $('#deletePage,.postSetting #deletePage').click(function () {
            var UI = UIkit;

            var oncancel = function (e) {
                modal.hide();
            };

            var onInsert = function (e) {
                axiosDeletePageOrPost({ slug_id: activeSlugID }).then(
                    result => {
                        RVwys.rigthbar.isJstree.Callbackoption(
                            result.data,
                            'deletePage',
                            activePageType
                        );
                        parent.$('.overlaypanel').remove();
                        console.pop.success({
                            text: result.data.data.message,
                            delay: 5000,
                        });
                    }
                );

                modal.hide();
            };

            var type = window.activePageType == 'blog' ? 'Post' : 'Page';
            console.log('page bane:' + window.activePageName);
            var modal = UI.modal.dialog(
                [
                    `<div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Delete ' + type)}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                <div class="uk-margin uk-modal-content">
                ${rvLang(
                    'Are you sure want to delete ' + type
                )} : ${activePageName}
                </div>
                <div class="uk-modal-footer uk-text-left clear">
                    <button class="uk-button  js-modal-confirm">${rvLang(
                        'Ok'
                    )}</button>
                    <button class="uk-button uk-button-success js-modal-confirm-cancel ">${rvLang(
                        'Cancel'
                    )}</button>
                </div>`,
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.js-modal-confirm')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        });

        $('#Duplicate,.postSetting #Duplicate').click(function () {
            $('.pageSetting').hide();
            console.log('Deuplicate page : ' + activePageName);

            var overlaypanel = $(
                '<div class="overlaypanel">' +
                    '<img class="loading" src="' +
                    wex.url.WYS_IMG_URL +
                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                    '</div>'
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });
            $('body').append(overlaypanel);

            axiosSetDuplicate({ slug_id: activeSlugID }).then(resposnse => {
                RVwys.rigthbar.isJstree.Callbackoption(
                    resposnse.data,
                    'Duplicate',
                    activePageType
                );
                console.pop.success({
                    text: resposnse.data.data.message,
                    delay: 5000,
                });
            });
        });

        $('#renamePage,.postSetting #renamePage').click(function (e) {
            console.log('click');

            var editviewRename = $('#editviewRename').html();
            $('#warningPageName').hide();
            $('.pageSetting').hide();

            var UI = UIkit;

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Rename') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewRename +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                });

            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });

            var onInsert = function () {
                if (
                    modal.element.find('#pageName').val().match(/^\s/) ==
                        null &&
                    modal.element.find('#pageName').val().trim().length > 0
                ) {
                    axiosRenamePageAndPost({
                        page_name: modal.element.find('#pageName').val().trim(),
                        slug_id: activeSlugID,
                    })
                        .then(resposnse => {
                            RVwys.rigthbar.isJstree.Callbackoption(
                                resposnse.data,
                                'rename',
                                activePageType
                            );
                            console.pop.success({
                                text: resposnse.data.message,
                                delay: 5000,
                            });
                            modal.hide();
                        })
                        .catch(err => {
                            console.pop.error({
                                text: err.data.message,
                            });
                        });
                } else {
                    modal.element.find('#warningPageName').show();
                    modal.element.find('#pageName').focus().select();
                }
            };

            var oncancel = function () {
                modal.hide();
            };

            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            modal.show();
            makeSlug(modal.element);
        });

        $('.Visibility_Rightbar,.Siteconfig').click(async function () {
            var oThis = $(this);

            var result = await BuildIframePageProperties();
            if (result) {
                var cmd = oThis.attr('cmd-site');
                var slugname = oThis.closest('li').attr('slug-name');

                var typepage =
                    window.activePageType != 'page' ? 'post' : 'page';

                window.SiteConfigIframe.SetCurrentTab(
                    typepage,
                    window.activeSlugID,
                    cmd
                );
            }
        });

        $('.config-setting').click(async function () {
            const result = await BuildIframePageProperties();
            if (result) {
                var cmd = $(this).attr('cmd-active');
                window.SiteConfigIframe.SetCurrentTab(cmd, '', '');
            }
        });

        $('.add-page').click(function () {
            RVwys.addPageModal();
        });

        $('.add-post').click(function () {
            RVwys.addPostModal();
        });

        // Sitebar

        $('#setting-page').click(function (e) {
            var overlaypanel = $(
                '<div class="overlaypanel overlaysite" style="position: fixed; z-index:0; "></div>'
            )
                .css({
                    width: $('body').width(),
                    height: $('body').height(),
                })
                .click(function () {
                    $('.rvsb-design-property').hide();
                    $(this).remove();
                });

            if (!$('.overlaypanel').get(0)) {
                $('body').append(overlaypanel);
            }

            $('.rightmenu-icon').removeClass('active-site');
            $('.rightmenu-icon').first().addClass('active-site');

            $('.wys-rowTwo').hide();
            $('.bar-right').addClass('bar-category-hidden');
            $('.bar-category').addClass('bar-category-hidden');

            $('.bar-right').removeClass('bar-category-hidden');
            $('.bar-page').removeClass('bar-category-hidden');

            $('#Countpage_onmenu').text(wex.page.page_tree.length);
            $('#Countpage_internal').text(wex.page.page_internal.length);

            if (wex.page.page_internal.length == 0) {
                $('.listtitle_internal').hide();
            }

            RVwys.rigthbar.isJstree.Recently();
            // Build JSTree
            RVwys.rigthbar.isJstree.createJSTrees(
                $('#listmenu'),
                wex.menu.menu_tree,
                {
                    type: 'menu',
                    iconType: {
                        ...customIconJStree.JStreeTypeIconPage(),
                        ...customIconJStree.JStreeTypeIconBlog(),
                        ...customIconJStree.JStreeTypeIconMenu(),
                    },
                }
            );
            RVwys.rigthbar.isJstree.createJSTrees(
                $('#listpage_onmenu'),
                wex.page.page_tree,
                {
                    type: 'page',
                    iconType: {
                        ...customIconJStree.JStreeTypeIconPage(),
                        ...customIconJStree.JStreeTypeIconSystem(),
                    },
                }
            );

            var listblog = wex.blog.blog_lists.concat(
                wex.blog.blog_listscategory
            );

            RVwys.rigthbar.isJstree.createJSTrees($('#listblog'), listblog, {
                type: 'blog',
                iconType: customIconJStree.JStreeTypeIconBlog(),
            });

            // active right menu
            var isTypeCurrent =
                parent.currentPageType.toLowerCase() == 'category'
                    ? 'post'
                    : parent.currentPageType.toLowerCase();

            $(`[onclick="bar_class('bar-${isTypeCurrent}')"]`).trigger('click');

            if (parent.currentPageType.toLowerCase() == 'post') {
                if (!wex.blog.blog_first) {
                    $('.bar-category-first').addClass('bar-category-hidden');
                }
            }

            RVwys.hidePanelAll();
        });

        $('#rv-design-sitemap').click(function () {
            if ($('#off_sitemap').attr('aria-expanded') === 'true') {
                $(this).find('.rvsb-switch').addClass('bgoff');
            }
            if ($('#off_sitemap').attr('aria-expanded') === 'false') {
                $(this).find('.rvsb-switch').removeClass('bgoff');
            }
        });

        var fb = $('#frameBody').get(0).contentWindow;

        if (fb.$('#back-top').attr('backtotop') == 1) {
            fb.$('#back-top').css('visibility', '');
            fb.$('#back-top').show();
            $('#backtop_onoff').prop('checked', true);
        }

        $('#rv-design-backtotop').click(function () {
            if ($('#off_backtop').attr('aria-expanded') === 'true') {
                $(this).find('.rvsb-switch').addClass('bgoff');
                fb.$('#back-top').css('visibility', 'hidden');
            } else {
                $(this).find('.rvsb-switch').removeClass('bgoff');
                fb.$('#back-top').css('visibility', '');
                fb.$('#back-top').show();
            }
        });

        $('#backtop_onoff').click(function () {
            console.log(fb.$('#back-top'));
            console.log(this.checked);

            if (this.checked) {
                fb.$('#back-top').css('visibility', '');
                fb.$('#back-top').show();
                RVwys.SaveBacktoTop('1');
            } else {
                fb.$('#back-top').css('visibility', 'hidden');
                RVwys.SaveBacktoTop('0');
            }
        });
        // End sitebar
        $('#blog_setHomePage').click(function () {
            console.log('Set homepage blog index : ' + activeSlugID);

            $('.blogSetting').hide();

            axiosSetToHome({ slug_id: activeSlugID })
                .then(result => {
                    RVwys.rigthbar.isJstree.CallbackoptionBlog(
                        result.data,
                        'sethome'
                    );

                    console.pop.success({
                        text: result.data.data.msg,
                        delay: 5000,
                    });
                })
                .catch(err => {
                    console.log('err: ', err);
                    console.pop.error({
                        text: err.data.data.msg,
                    });
                });
        });

        $('#blog_setHide').click(function () {
            $.ajax({
                type: 'POST',
                url: wex.url.baseUrl + '/admin/blog/sethide',
                data: {
                    slug_id: activeSlugID,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (data) {
                    RVwys.rigthbar.isJstree.CallbackoptionBlog(
                        data.data,
                        'sethide'
                    );

                    console.pop.success({
                        text: 'Set as hide ' + data.data.msg,
                        delay: 5000,
                    });
                },
            });
        });

        $('#blog_unsetHide').click(function () {
            console.log('Set unsethide blog : ' + activeSlugID);
            $('.blogSetting').hide();

            $.ajax({
                type: 'POST',
                url: wex.url.baseUrl + '/admin/blog/sethide',
                data: {
                    slug_id: activeSlugID,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (data) {
                    RVwys.rigthbar.isJstree.CallbackoptionBlog(
                        data.data,
                        'unsethide'
                    );

                    console.pop.success({
                        text: 'Unhide ' + data.data.msg,
                        delay: 5000,
                    });
                },
            });
        });

        $('#blog_delete:not(.disable-delete)').on('click', function () {
            if (!$(this).hasClass('disable-delete')) {
                var UI = UIkit;

                var options = {
                    bgclose: false,
                    keyboard: false,
                    modal: false,
                };
                oncancel = function (e) {
                    modal.hide();
                };

                var onInsert = function (e) {
                    $.ajax({
                        type: 'POST',
                        url:
                            wex.url.baseUrl +
                            '/admin/category/category/ajaxdeletecategory',
                        data: {
                            slug_id: activeSlugID,
                            _token: $('meta[name="csrf-token"]').attr(
                                'content'
                            ),
                        },
                        success: function (data) {
                            var fb = $('#frameBody').get(0).contentWindow;

                            if (
                                fb.$(
                                    `#selected_navigator [slug-id="${activeSlugID}"]`
                                )
                            ) {
                                fb.$(
                                    `#selected_navigator [slug-id="${activeSlugID}"]`
                                ).remove();
                            }

                            modal.hide();

                            wex.blog.blog_categories.splice(
                                window.activeIndexKey - 1,
                                1
                            );
                            wex.blog.blog_listscategory.splice(
                                window.activeIndexKey,
                                1
                            );

                            var connect = wex.blog.blog_lists.concat(
                                wex.blog.blog_listscategory
                            );
                            RVwys.rigthbar.isJstree.refresh(
                                $('#listblog'),
                                connect,
                                'blog'
                            );

                            $('.rvsb-design-property').hide();
                            parent.$('.overlaypanel').remove();
                            console.pop.success({
                                text: data.data.msg,
                                delay: 5000,
                            });
                        },
                    });
                };

                var modal = UI.modal.dialog(
                    [
                        '<div class="uk-margin uk-modal-header"><h2>' +
                            rvLang('Delete Page') +
                            '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                        '<div class="uk-margin uk-modal-content">' +
                            rvLang('Are you sure want to delete Category') +
                            ': ' +
                            window.activeBlogname +
                            '</div>',
                        '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                            rvLang('Ok') +
                            '</button>',
                        '<button class="uk-button js-modal-confirm-cancel ">' +
                            rvLang('Cancel') +
                            '</button></div>',
                    ].join(''),
                    options
                );

                modal.element
                    .find('.js-modal-confirm-cancel')
                    .on('click', function () {
                        oncancel();
                    })
                    .end()
                    .find('.uk-button-success')
                    .on('click', function () {
                        onInsert();
                    });

                modal.show();
            }
        });

        $('#blog_rename').click(function (e) {
            console.log($('#blogName'));
            var editviewRename = $('#Renameblog').html();

            $('.rvsb-design-property').hide();

            var UI = UIkit;

            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Rename') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        editviewRename +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Save') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('Cancel') +
                        '</button></div>',
                ].join(''),
                options
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.element.find('#blogName').val(window.activeBlogname);

            modal.show();

            var onInsert = function () {
                var renameBlog = modal.element.find('#blogName').val().trim();

                var urlRoute = '/admin/category/category/ajaxrenamecategory';

                // if (window.blogindex) {
                //     urlRoute = '/admin/blog/rename';
                // }

                $.ajax({
                    type: 'POST',
                    url: wex.url.baseUrl + urlRoute,
                    data: {
                        category_name: renameBlog,
                        slug_id: activeSlugID,
                        _token: $('meta[name="csrf-token"]').attr('content'),
                    },
                    error: function (data) {
                        console.inline.error({
                            target: modal.element.find('.warningblogName'),
                            text: data.responseJSON.errors.category_name,
                            delay: 5000,
                        });
                    },
                    success: function (data) {
                        if (!window.blogindex) {
                            var callback = function (dataRespon) {
                                // Update blog_categories
                                var indexblog_categories = $.map(
                                    wex.blog.blog_categories,
                                    function (obj, index) {
                                        return obj.slug_id;
                                    }
                                ).indexOf(dataRespon.slug);

                                wex.blog.blog_categories[
                                    indexblog_categories
                                ].slug_name = dataRespon.slug_name;
                                wex.blog.blog_categories[
                                    indexblog_categories
                                ].text = renameBlog;
                                // Update blog_lists
                                $.each(wex.blog.blog_lists, function (k, obj) {
                                    if (
                                        obj.category_name ==
                                        window.activeBlogname
                                    ) {
                                        wex.blog.blog_lists[
                                            k
                                        ].category_name = renameBlog;
                                        wex.blog.blog_lists[k].slug_prefix =
                                            dataRespon.slug_prefix;
                                    }
                                });
                            };
                        } else {
                            callback = function (dataRespon) {
                                var fb = parent.$('#frameBody').get(0)
                                    .contentWindow;

                                var currenrMenu = fb
                                    .$('#selected_navigator,#selected_topmenu')
                                    .find(`li[slug-id="${dataRespon.slug}"]`);

                                if (currenrMenu) {
                                    var NavIcon = $(
                                        currenrMenu.find('span i')[0]
                                    ).prop('outerHTML');
                                    currenrMenu.attr('menu-title', renameBlog);
                                    currenrMenu
                                        .children('a')
                                        .children('span')
                                        .html(`${NavIcon}${renameBlog} `);
                                }
                                var blogIndexID =
                                    wex.blog.blog_listscategory[
                                        dataRespon.indexblog_listscategory
                                    ].id;
                                $.each(
                                    wex.blog.blog_listscategory,
                                    function (key, value) {
                                        if (blogIndexID == value.parent) {
                                            value.slug_prefix =
                                                dataRespon.slug_prefix;
                                            value.url =
                                                dataRespon.slug_prefix +
                                                '/' +
                                                value.slug_name +
                                                '/';
                                        }
                                    }
                                );

                                // Update blog_categories
                                $.each(
                                    wex.blog.blog_categories,
                                    function (key, value) {
                                        value.slug_prefix =
                                            dataRespon.slug_prefix;
                                    }
                                );

                                // Update blog_lists
                                $.each(
                                    wex.blog.blog_lists,
                                    function (key, value) {
                                        value.slug_prefix =
                                            dataRespon.slug_prefix +
                                            '/' +
                                            value.category_slug_name;
                                        value.url =
                                            dataRespon.slug_prefix +
                                            '/' +
                                            value.category_slug_name +
                                            '/' +
                                            value.slug_name +
                                            '/';
                                    }
                                );
                            };
                        }

                        responUpdateBlog(data, renameBlog, callback);

                        modal.hide();
                    },
                });
            };

            oncancel = function () {
                modal.hide();
            };
        });
    });

    function setHomeBlogIndex(params) {}

    function responUpdateBlog(data, renameBlog, callback = null) {
        // Update Wex :June
        var slug = parseInt(data.data.slug_id);
        var slug_prefix = data.data.slug_prefix;
        var slug_name = data.data.slug_name;

        const indexblog_listscategory = $.map(
            wex.blog.blog_listscategory,
            function (obj, index) {
                return obj.text;
            }
        ).indexOf(window.activeBlogname);

        wex.blog.blog_listscategory[indexblog_listscategory].slug_name =
            data.data.slug_name;

        wex.blog.blog_listscategory[indexblog_listscategory].text = renameBlog;

        var dataRespon = {
            slug: slug,
            slug_prefix: slug_prefix,
            slug_name: slug_name,
            indexblog_listscategory: indexblog_listscategory,
        };
        if (callback) {
            callback(dataRespon);
        }

        if (slug == parent.currentSlugID) {
            parent.$('#cmsCurrent').text(renameBlog);
            window.history.pushState('data', 'Title', slug_name);
        }

        var connect = wex.blog.blog_lists.concat(wex.blog.blog_listscategory);
        RVwys.rigthbar.isJstree.refresh($('#listblog'), connect, 'blog');

        console.pop.success({
            text: data.msg,
            delay: 5000,
        });
        $('.overlaypanel').remove();
    }

    function makeSlug(ModalElement) {
        console.log(parent.activePageName);
        console.log(window.activePageName);
        var newSlug;
        ModalElement.find('#pageName').val(parent.activePageName);
        parent.$('#pageUrl').val(parent.activeSlug);

        ModalElement.find('#pageName').keydown(function () {
            var BeforepageName = parent.$('#pageName').val().trim();

            ModalElement.find('#pageName').keyup(function () {
                var pageNameConvert = BeforepageName;
                pageNameConvert = pageNameConvert
                    .replace(/\W+(?!$)/g, '-')
                    .toLowerCase();
                pageNameConvert = pageNameConvert
                    .replace(/\W$/, '')
                    .toLowerCase();

                var pageUrl = parent.$('#pageUrl').val();
                if (
                    (BeforepageName === pageUrl) |
                    (pageNameConvert === pageUrl)
                ) {
                    var str = $(this).val();
                    str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
                    str = str.replace(/\W$/, '').toLowerCase();

                    parent.$('#pageUrl').val(str);
                }
            });
        });

        parent.$('#pageUrl').on('keyup', function (e) {
            var str = $(this).val().trim();
            str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
            str = str.replace(/ /g, '-').replace(/-+/g, '-').replace(/^-/g, '');
        });

        parent.$('#pageUrl').blur(function () {
            var ajaxSlug = '';
            var str = $(this).val().trim();
            str = str.replace(/\W$/, '').toLowerCase();
            if (str == '') {
                str = ModalElement.find('#pageName').val();
                str = str.replace(/\W+(?!$)/g, '-').toLowerCase();
                str = str.replace(/\W$/, '').toLowerCase();
            }

            if ($(this).val() != parent.activeSlug) {
                RVwys.checkSlug(str, function (returnValue) {
                    ajaxSlug = returnValue;
                    parent.$('#pageUrl').val($.trim(ajaxSlug));
                });
            } else {
                $(this).val(str);
            }
        });

        ModalElement.find('#pageName').blur(function () {
            if ($(this).val() == '') {
                ModalElement.find('#pageName').val(parent.activePageName);
            }
            if (parent.$('#pageUrl').val() == '') {
                parent.$('#pageUrl').val(parent.activeSlug);
            }
        });
    }

    function getpricat(ElementModal) {
        var pricat = '';
        ElementModal.find('.spancatselect').each(function () {
            if ($(this).hasClass('oncategorypri') && $(this).html() != '') {
                pricat = $(this).attr('id');
            }
        });
        // if not select primary cat to get frist in cat make is primary
        if (pricat == '') {
            ElementModal.find('.spancatselect').each(function () {
                if ($(this).hasClass('oncategory') && $(this).html() != '') {
                    // alert($(this).attr("id"));
                    pricat = $(this).attr('id');
                    return false;
                }
            });
        }
        if (pricat == '') {
            pricat = ElementModal.find('.spancatselect').first().attr('id');
        }
        return pricat;
    }

    function getpostincat(ElementModal) {
        var postincat = [];
        ElementModal.find('.spancatselect').each(function () {
            if (
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri')) &&
                $(this).html() != ''
            ) {
                postincat.push($(this).attr('id'));
            }
        });
        // if not select category to push 1 to cat
        if (postincat.length === 0) {
            postincat.push(
                ElementModal.find('.spancatselect').first().attr('id')
            );
        }
        return postincat;
    }

    // ajax with callback
    function doAnAjax(url, data, type, callback) {
        $.ajax({
            url: url,
            data: data,
            cache: false,
            type: type,
            error: function (jqXHR, textStatus, errorThrown) {
                callback('error', jqXHR);
            },
            success: function (data) {
                callback('success', data);
            },
        });
    }

    function catmakePrimary(idname, ElementModal) {
        ElementModal.find('.spancatselect').each(function () {
            if (
                $(this).attr('id') != idname &&
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri'))
            ) {
                console.log('FN :: catmakePrimary :: Make Primary');

                $(this).html('Make Primary');
                $(this).removeClass('oncategorypri');
                $(this).addClass('oncategory');
            }

            if (
                $(this).attr('id') == idname &&
                ($(this).hasClass('oncategory') ||
                    $(this).hasClass('oncategorypri'))
            ) {
                console.log('FN ::  catmakePrimary :: Primary');

                $(this).html('Primary');
                $(this).removeClass('oncategory');
                $(this).addClass('oncategorypri');
                RVwys.CheckVisibility(true, idname, true, ElementModal);
            }
        });
    }

    function postCreateValidate(ElementModal) {
        var allcatname = [];
        ElementModal.find('#postCatSelect input').each(function () {
            allcatname.push($(this).attr('name'));
        });

        // alert(JSON.stringify(allcatname));
        ElementModal.find('#postCatName').removeClass(
            'uk-alert uk-alert-danger'
        );
        ElementModal.find('#postCatName_error').addClass('uk-hidden');
        if (ElementModal.find('#postCatName').val() == '') {
            ElementModal.find('#postCatName').addClass(
                'uk-alert uk-alert-danger'
            );
            ElementModal.find('#postCatName_error').html(
                'Oh! You forget to add name for the new category!'
            );
            ElementModal.find('#postCatName_error').removeClass('uk-hidden');
            return false;
        }

        console.log('====================================');
        console.log(allcatname);
        console.log('====================================');
        // if (
        //     $.inArray(ElementModal.find('#postCatName').val(), allcatname) !==
        //     -1
        // ) {
        //     ElementModal.find('#postCatName').addClass(
        //         'uk-alert uk-alert-danger'
        //     );
        //     ElementModal.find('#postCatName_error').html(
        //         'Category name duplicated!'
        //     );
        //     ElementModal.find('#postCatName_error').removeClass('uk-hidden');
        //     return false;
        // }
        return true;
    }

    function addcategory(ElementModal) {
        var catname = ElementModal.find('#postCatName').val();
        var parent = ElementModal.find('#postCatParent option:selected').val();

        var url = '/admin/category/category/ajaxsavecategory';
        var param = {
            catname: catname,
            parent: parent,
        };
        doAnAjax(url, param, 'get', function (status, data) {
            if (status == 'success') {
                var htmlchkbox = getCategoryCheckbox(data.cat);
                var htmlselbox = getCategoryselectbox(data.cat);
                ElementModal.find('#postCatSelect').html(htmlchkbox);
                ElementModal.find('#postCatParent').html(htmlselbox);

                eventpost(ElementModal);

                var wexcatList = {
                    id: 'category' + data.id,
                    parent: wex.blog.blog_listscategory[0].id,
                    slug_id: data.slug_id,
                    slug_name: data.slug_name,
                    slug_prefix: 'blog',
                    text: data.lastCat,
                    type: 'category',
                };
                wex.blog.blog_listscategory.push(wexcatList);

                var type = data.parent_id == '0' ? '#' : data.parent_id;

                var wexCat = {
                    id: data.id,
                    category_name: data.lastCat,
                    parent: type,
                    parent_id: parseInt(data.parent_id),
                    text: data.lastCat,
                };

                wex.blog.blog_categories.push(wexCat);

                ElementModal.find('#groupCreateCat').addClass('uk-hidden');
                ElementModal.find('#postCatName').val('');

                return;
            }
            const msgError = data.responseJSON.errors.catname;
            ElementModal.find('#postCatName_error')
                .html(msgError)
                .removeClass('uk-hidden');
        });
    }

    function getCategoryCheckbox(catlist) {
        // for checkbox cat
        var htmlchkbox = '';
        $.each(catlist, function (i, cat) {
            // alert(cat.category_name);
            htmlchkbox =
                htmlchkbox +
                '<li><input id="" value="' +
                cat.id +
                '" name="' +
                cat.category_name +
                '" type="checkbox" class="catSelect" visibility="' +
                cat.visibility +
                '">' +
                ' ' +
                cat.category_name +
                '  <i class="icon-visibility bcate-' +
                cat.visibility_icon +
                '"></i><span class="poststatus">(' +
                cat.role_name +
                ') </span>' +
                ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                cat.id +
                '" id="' +
                cat.id +
                '"></button>';
            $.each(cat.subcategories, function (i, subcat1) {
                console.log('-------subcat1-------');
                console.log(subcat1);
                // alert(subcat1.category_name);
                htmlchkbox =
                    htmlchkbox +
                    '<ul class="list-tree1"><li><input id="" value="' +
                    subcat1.id +
                    '" name="' +
                    subcat1.category_name +
                    '" type="checkbox" class="catSelect" visibility="' +
                    subcat1.visibility +
                    '">' +
                    ' ' +
                    subcat1.category_name +
                    ' <i class="icon-visibility bcate-' +
                    subcat1.visibility_icon +
                    '"></i><span class="poststatus" >(' +
                    subcat1.role_name +
                    ') </span>' +
                    ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                    subcat1.id +
                    '" id="' +
                    subcat1.id +
                    '"></button>';
                $.each(subcat1.subcategories, function (i, subcat2) {
                    console.log('-------subcat2-------');
                    console.log(subcat2);
                    // alert(subcat2.category_name);
                    htmlchkbox =
                        htmlchkbox +
                        '<ul class="list-tree2"><li><input id="" value="' +
                        subcat2.id +
                        '" name="' +
                        subcat2.category_name +
                        '" type="checkbox" class="catSelect" visibility="' +
                        subcat2.visibility +
                        '">' +
                        ' ' +
                        subcat2.category_name +
                        ' <i class="icon-visibility bcate-' +
                        subcat2.visibility_icon +
                        '"></i><span class="poststatus">(' +
                        subcat2.role_name +
                        ') </span>' +
                        ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                        subcat2.id +
                        '" id="' +
                        subcat2.id +
                        '"></button>';
                    $.each(subcat2.subcategories, function (i, subcat3) {
                        console.log('-------subcat3-------');
                        console.log(subcat3);
                        // alert(subcat3.category_name);
                        htmlchkbox =
                            htmlchkbox +
                            '<ul class="list-tree3"><li><input id="" value="' +
                            subcat3.id +
                            '" name="' +
                            subcat3.category_name +
                            '" type="checkbox" class="catSelect" visibility="' +
                            subcat3.visibility +
                            '">' +
                            ' ' +
                            subcat3.category_name +
                            ' <i class="icon-visibility bcate-' +
                            subcat3.visibility_icon +
                            '"></i><span class="poststatus">(' +
                            subcat3.role_name +
                            ') </span>' +
                            ' <button class="uk-button uk-button-link spancatselect catSelect_' +
                            subcat3.id +
                            '" id="' +
                            subcat3.id +
                            '"></button> </li></ul>';
                    });
                    htmlchkbox = htmlchkbox + '</li></ul>';
                });
                htmlchkbox = htmlchkbox + '</li></ul>';
            });
            htmlchkbox = htmlchkbox + '</li>';
        });
        return htmlchkbox;
    }

    function getCategoryselectbox(catlist) {
        // for parent cat
        var htmlselbox;
        $.each(catlist, function (i, cat) {
            // alert(cat.category_name);
            htmlselbox += `<option value="${cat.id}">${cat.category_name}</option>`;
            $.each(cat.subcategories, function (i, subcat1) {
                // alert(subcat1.category_name);
                htmlselbox += `<option value="${subcat1.id}">| - ${subcat1.category_name}</option>`;
                $.each(subcat1.subcategories, function (i, subcat2) {
                    // alert(subcat2.category_name);
                    htmlselbox += `<option value="${subcat2.id}">| --- ${subcat2.category_name}</option>`;
                    $.each(subcat2.subcategories, function (i, subcat3) {
                        // alert(subcat3.category_name)
                        htmlselbox += `<option value="${subcat3.id}" disabled>| ------ ${subcat3.category_name}</option>`;
                    });
                });
            });
        });
        return htmlselbox;
    }

    function eventpost(ElementModal) {
        // select catagory
        ElementModal.find('.catSelect').on('change', function () {
            console.log('isCheck ==> ' + this.checked);
            var btnPri = ElementModal.find(
                '.catSelect[value=' + $(this).val() + ']'
            )
                .closest('li')
                .find('.spancatselect')
                .first();
            var isCheck = this.checked;
            var isPrimary = btnPri.hasClass('oncategorypri');
            if (isCheck) {
                // Check has Primary
                if (
                    !ElementModal.find('.spancatselect').hasClass(
                        'oncategorypri'
                    )
                ) {
                    btnPri.text('Primary');
                    btnPri.removeClass('oncategory');
                    btnPri.addClass('oncategorypri');

                    RVwys.CheckVisibility(
                        isCheck,
                        $(this).val(),
                        true,
                        ElementModal
                    );
                } else {
                    btnPri.text('Make Primary');
                    btnPri.removeClass('oncategorypri');
                    btnPri.addClass('oncategory');
                }
            } else {
                btnPri.text('');
                btnPri.removeClass('oncategory');
                btnPri.removeClass('oncategorypri');

                if (isPrimary) {
                    RVwys.CheckVisibility(
                        isCheck,
                        $(this).val(),
                        true,
                        ElementModal
                    );
                    // set new primary by first select
                    ElementModal.find('.spancatselect').each(function () {
                        if ($(this).hasClass('oncategory')) {
                            $(this).addClass('oncategorypri');
                            $(this).html('Primary');
                            var id = $(this).attr('id');
                            RVwys.CheckVisibility(true, id, true, ElementModal);
                        }
                    });
                }
            }

            // catselect(this.checked,$(this).val(),ElementModal);
        });
        // take off General check default
        // $('#postCatSelect').find('input.catSelect[name=General]').prop('checked',
        // true);
        // $(".catSelect").trigger( "change" );

        // make primary
        ElementModal.find('.spancatselect').on('click', function () {
            if (!$(this).hasClass('oncategorypri')) {
                catmakePrimary($(this).attr('id'), ElementModal);
            }
        });

        // add cat box
        ElementModal.find('#postCatAdd').on('click', function () {
            ElementModal.find('#groupCreateCat').removeClass('uk-hidden');
        });
    }

    RVwys.CheckVisibility = function (
        Checked,
        inputID,
        isPrimary,
        ElementModal
    ) {
        console.log(
            '//////////////////////////////////////////////////////////'
        );
        console.log('FN::RVwys.CheckVisibility');
        console.log(Checked + ' <------> ' + inputID);

        var visibility = ElementModal.find(
            '.catSelect[value=' + inputID + ']'
        ).attr('visibility');

        if (Checked) {
            console.log('isPrimary ---> ' + isPrimary);
            console.log('visibility ---> ' + visibility);

            if (visibility == '1') {
                console.log('visibility 1');

                var oThis = ElementModal.find('.catSelect[visibility=0]');

                oThis.prop({
                    disabled: true,
                });
                oThis.prop({
                    checked: false,
                });

                if (isPrimary) {
                    var catselect = oThis.closest('li').find('.spancatselect');

                    $.each(catselect, function () {
                        var ckInput = $(this)
                            .closest('li')
                            .find('input')
                            .first();
                        if (!ckInput.prop('checked')) {
                            $(this).text('');
                            $(this)
                                .removeClass('oncategory')
                                .removeClass('oncategorypri');
                        }
                    });
                }
            } else if (visibility == '2') {
                console.log('visibility 2');
                oThis = ElementModal.find('.catSelect[visibility!=2]');
                oThis.prop({
                    disabled: true,
                });
                oThis.prop({
                    checked: false,
                });

                if (isPrimary) {
                    catselect = oThis.closest('li').find('.spancatselect');
                    $.each(catselect, function () {
                        var ckInput = $(this)
                            .closest('li')
                            .find('input')
                            .first();
                        if (!ckInput.prop('checked')) {
                            $(this).text('');
                            $(this)
                                .removeClass('oncategory')
                                .removeClass('oncategorypri');
                        }
                    });
                }
            } else {
                console.log('visibility 0');
                ElementModal.find('.catSelect[visibility]').prop({
                    disabled: false,
                });
            }
        } else {
            ElementModal.find(
                '.catSelect[visibility!=' + visibility + ']'
            ).prop({
                disabled: false,
            });
        }
    };
    RVwys.addPostModal = function () {
        var editviewAddPost = $('#editviewAddPost').html();
        var UI = UIkit;
        var modal = UI.modal.dialog(
            [
                `<div class="wys-rvcontent">
                <div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Add Post')}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                    <div class="uk-margin uk-modal-content">${editviewAddPost}</div>
                <div class="uk-modal-footer uk-text-left clear">
                    <button class="uk-button uk-button-primary uk-button-success-addpost  js-modal-confirm">
                        ${rvLang('Save')}
                    </button>
                    <button class="uk-button js-modal-confirm-cancel-addpost">
                        ${rvLang('Cancel')}
                    </button>
                </div>
            </div>`,
            ].join(''),
            {
                bgclose: false,
                keyboard: false,
                modal: false,
            }
        );

        modal.element
            .find('.js-modal-confirm-cancel-addpost')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success-addpost')
            .on('click', function () {
                onInsert();
            });
        modal.show();

        var onInsert = function () {
            var postname = modal.element.find('#postName').val();
            var incat = [];
            incat = getpostincat(modal.element);
            var pricat = getpricat(modal.element);
            var url = '/admin/blog/blog/createpost';
            var data = {
                post_name: postname,
                save_img: 1,
                incat: incat,
                pricat: pricat,
                _token: $('meta[name="csrf-token"]').attr('content'),
            };
            // var data = {'post_name':postname,'incat':incat,'pricat':pricat,_token : $('meta[name="csrf-token"]').attr('content')};

            $.ajax({
                method: 'POST',
                url: url,
                data: data,
                dataType: 'json',
            })
                .done(function (data) {
                    var url = '/' + data.url;
                    window.location.href = parent.wex.url.WYS_SHOW_URL + url;

                    modal.hide();
                })
                .fail(function (jqXHR, textStatus) {
                    var msg = jqXHR.responseJSON.errors.post_name[0];

                    console.inline.error({
                        target: modal.element.find('#postName_error'),
                        title: Error,
                        text: msg,
                        delay: 5000,
                    });
                });
        };

        var oncancel = function () {
            modal.hide();
        };

        // query all category postCatSelect
        var htmlchkbox = '';
        var htmlselbox = '';
        var url = '/admin/category/category/ajaxgetcategory';
        doAnAjax(url, {}, 'get', function (error, data) {
            if (data.status == 'success') {
                htmlchkbox = getCategoryCheckbox(data.cat);
                htmlselbox = getCategoryselectbox(data.cat);
                modal.element.find('#postCatSelect').html(htmlchkbox);
                modal.element.find('#postCatParent').html(htmlselbox);

                eventpost(modal.element);
            }
        });

        // add cat
        modal.element.find('#postCreateCat').on('click', function (e) {
            var valid = postCreateValidate(modal.element);
            // alert(valid);
            if (valid) {
                addcategory(modal.element);
            }
        });
    };

    RVwys.addPageModal = function () {
        var fb = $('#frameBody').get(0).contentWindow;
        var editviewAddPage = $('#editviewAddPage').html();

        const pageSetting = $('.pageSetting') ?? fb.$('.pageSetting');
        pageSetting.hide();

        const barPage = $('.bar-page') ?? fb.$('.bar-page');
        barPage.addClass('bar-category-hidden');

        const barRight = $('.bar-right') ?? fb.$('.bar-right');
        barRight.addClass('bar-category-hidden');

        var overlaypanel = $(
            `<div class="overlaypanel">
                <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
            </div>`
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        var UI = parent.UIkit;
        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var onInsert = function () {
            // Add page and add menu
            var isShow = modal.element.find('#showOnMenu').is(':checked');
            if (isShow) {
                var showMenu = 1;
            } else {
                showMenu = 0;
            }
            $('#warningPageName').hide();

            var overlaypanel = $(
                `<div class="overlaypanel">
                    <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
                </div>`
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });
            $('body').append(overlaypanel);
            var page_name = modal.element.find('#pageName').val();

            axiosAddPage({ page_name: page_name, showMenu: showMenu })
                .then(result => {
                    setTimeout(function () {
                        window.location.href = `${parent.wex.url.WYS_SHOW_URL}/
                            ${result.data.new_slug};`;
                    }, 1000);
                    modal.hide();
                })
                .catch(err => {
                    parent.$('.overlaypanel').remove();

                    var err_page = err.data.errors.page_name;
                    modal.element.find('#msgerrAddpage').html('');
                    $.each(err_page, function (k, v) {
                        // modal.element.find();
                        console.inline.error({
                            target: modal.element.find('#msgerrAddpage'),
                            text: v,
                            delay: 5000,
                        });
                    });
                });
        };

        var oncancel = function () {
            modal.hide();
        };

        var modal = UI.modal.dialog(
            [
                `<div class="wys-rvcontent">
                <div class="uk-margin uk-modal-header">
                    <h2>${rvLang('Add Page')}</h2>
                    <span class="uk-modal-close uk-icon-close"></span>
                </div>
                <div class="uk-margin uk-modal-content">${editviewAddPage}</div>
                <div class="uk-modal-footer uk-text-left clear">
                    <br>
                    <button class="uk-button uk-button-success  js-modal-confirm">
                        ${rvLang('Save')}
                    </button>
                    <button class="uk-button js-modal-confirm-cancel">
                        ${rvLang('Cancel')}
                    </button>
                </div>
            </div>`,
            ].join(''),
            options
        );

        modal.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
            });
        modal.show();
    };

    RVwys.SaveBacktoTop = function (oThis) {
        var backtotop = oThis;
        axiosSaveSettingBacktotop({ backtotop: backtotop }).then(result => {
            $('#frameBody')
                .get(0)
                .contentWindow.$('#back-top')
                .attr('backtotop', backtotop);
        });
    };

    // fn::JStree
    RVwys.rigthbar.isJstree.Eventjstree = function ($this) {
        var isThis = $this.closest('#listblog').length
            ? '.postSetting '
            : '.pageSetting';
        var isSetting = $this.closest('#listblog').length
            ? 'postSetting'
            : 'pageSetting';

        console.log('$this: ', $this);
        var isPublic = $this.attr('is-published') == 1 ? true : false;

        var parentPubilc =
            $this.parent().closest('li').attr('is-published') == 1
                ? true
                : false;

        parentPubilc;

        var getJstree = !$this.closest('div').jstree(true)
            ? parent.$('#' + $this.closest('div').attr('id')).jstree(true)
            : $this.closest('div').jstree(true);
        var isChild = getJstree.get_node($this.attr('id')).children.length > 0;
        var isCategory = parent.activeType == 'category' ? true : false;

        var parentPubilc = true;
        if (isChild) {
            var $parentNode = $this.parent().closest('li');
            console.log('$parentNode: ', $parentNode);

            $this.parent().closest('li').attr('is-published') == 1
                ? true
                : false;
        }

        console.log('*******************************************');
        console.log('isChild - ', isChild);
        console.log('parentPubilc - ', parentPubilc);
        console.log('isPublic - ', isPublic);

        if (parentPubilc) {
            parent.$(isThis + ' #setHide').toggle(isPublic);
            parent.$(isThis + ' #unsetHide').toggle(!isPublic);
        }

        var isHomepage =
            $this.attr('is-homepage') == 1 ||
            $this.attr('is-homepage') === 'true'
                ? true
                : false;

        parent.$(isThis + ' #deletePage').toggle(!isHomepage);
        parent.$(isThis + ' #setHomePage').toggle(!isHomepage);

        if ($this.attr('slug-id') == parent.currentSlugID) {
            parent.$(isThis + ' #deletePage').hide();
        }

        if (isChild) {
            parent.$(isThis + ' #deletePage').toggle(!isHomepage);
        }

        // console.log($this.attr('page-name'));
        $('.rvsb-design-property').hide();
        parent.$(isThis + ' #titlePage').text(parent.activePageName);
        parent.$('.' + isSetting).show();
        var positionsetting = $this.position();

        var Maxh = screen.height - positionsetting.top;
        if (Maxh < 350) {
            parent.$('.' + isSetting).css({
                right: '200px',
                top: '410',
            });
        } else {
            parent.$('.' + isSetting).css({
                right: '200px',
                top: positionsetting.top - 5,
            });
        }
        // console.log('Top'+positionSettingPage.top+'- Height'+screen.height+'=');
        // console.log(screen.height-positionSettingPage.top)
    };

    RVwys.rigthbar.isJstree.Callbackoption = function (
        data,
        typeoption,
        typebar = 'page'
    ) {
        var element =
            $('#' + parent.eleActive).length > 0
                ? $('#' + parent.eleActive)
                : parent.$('#' + parent.eleActive);

        var oLi = $('.liListPage[slug-id=' + parent.activeSlugID + ']');

        var isType = element.closest('div').attr('id');

        var otOpt = {
            setHide: {},
            unsetHide: {},
        };

        otOpt.setHide.optPage = 0;
        otOpt.setHide.status =
            typebar == 'page' ? 'page-normal-hide' : 'post-normal-hide';
        otOpt.setHide.sPage = '<i class="uk-icon-edit"></i><span>Draft</span>';

        otOpt.unsetHide.optPage = 1;
        otOpt.unsetHide.status = typebar == 'page' ? typebar : 'post';
        otOpt.unsetHide.sPage = '<i class="uk-icon-globe"><span>Public</span>';

        var typepage = {
            page: {},
            blog: {},
        };

        typepage.page.type = 'page';

        typepage.page.Json = 'page_tree';
        typepage.page.recently = 'page_recently';

        typepage.blog.type = 'blog';
        typepage.blog.Json = 'blog_lists';
        typepage.blog.jsonCat = 'blog_listscategory';
        typepage.blog.recently = 'blog_recently';

        var beforeSlug = parent.activeSlug;
        var afterSlug = data.data.page_name;
        var isData = data.data;

        var isEle = element.find('[slug-id=' + isData.slug_id + ']');
        var isEleID = isEle.attr('id');
        var isEletype = isEle.attr['page-type'];
        var isEleslugID = parseInt(isEle.attr['slug-id']);
        var isThis = element.find(
            '#' + isEleID + '[page-type=' + isEletype + ']'
        );
        var IndexKey = element.find('#' + isEleID).attr('indexkey');
        var isType = element.closest('div').attr('id');
        var pageJson = isType.match(/^list(.*)/im)[1].toLowerCase();

        var indexRecent = $.map(
            parent.wex[typebar][typepage[typebar].recently],
            function (obj) {
                return obj.text;
            }
        ).indexOf(parent.activePageName);

        var isEleRecent = typebar == 'page' ? 'RecentPage' : 'RecentPost';

        switch (typeoption) {
            case 'setHide':
            case 'unsetHide':
                var objFindThisKey =
                    parent.wex[typebar][typepage[typebar].Json][IndexKey];

                objFindThisKey.type = otOpt[typeoption].status;
                objFindThisKey.is_published = otOpt[typeoption].optPage;

                if (isData.slug_id == parent.currentSlugID) {
                    parent
                        .$('.current-optionPage')
                        .attr('is-pulbic', otOpt[typeoption].optPage);
                    // parent.$('#cmsStatus').html(otOpt[typeoption].sPage);

                    if (typeoption == 'setHide') {
                        parent
                            .$('#CurrentType')
                            .closest('.sprite-icon-visibility')
                            .css('opacity', '0.5');
                    } else {
                        parent
                            .$('#CurrentType')
                            .closest('.sprite-icon-visibility')
                            .removeAttr('style');
                    }
                }

                var isSetHide = typeoption == 'setHide';
                $(`#selected_navigator li[menu-slug='${beforeSlug}']
                [slug-id='${isData.slug_id}'] a`)
                    .first()
                    .toggleClass('draftmenu', isSetHide);

                // parent.$('#setting-page').trigger('click');

                break;

            case 'setHomePage':
                var objpage = {
                    0: 'page_onmenu',
                    1: 'page_internal',
                };
                var visibilityIcon =
                    parent.wex[typebar][typepage[typebar].Json][IndexKey].type;

                $.each(objpage, function (k, objpage) {
                    var indexHome = $.map(
                        parent.wex[typebar][objpage],
                        function (obj, index) {
                            return obj.is_homepage;
                        }
                    ).indexOf(1);

                    if (indexHome != -1) {
                        parent.wex[typebar][objpage][indexHome].is_homepage = 0;
                        parent.wex[typebar][objpage][
                            indexHome
                        ].type = visibilityIcon;

                        const isSlug =
                            parent.wex[typebar][objpage][indexHome].slug_id;
                        if (parent.currentSlugID == isSlug) {
                            const classIcon = parent
                                .$('#CurrenttypeIcon')
                                .attr('class')
                                .match(/icon\-visibility\s(.*)/)[1];

                            visibilityIcon =
                                visibilityIcon == 'restricted'
                                    ? 'specific'
                                    : visibilityIcon;

                            visibilityIcon =
                                visibilityIcon == 'internal-member'
                                    ? 'member'
                                    : visibilityIcon;

                            const changIcon =
                                parent.wex.iconvisibility[typebar].parent[
                                    visibilityIcon
                                ];

                            parent
                                .$('#CurrenttypeIcon')
                                .removeClass(`${classIcon}`)
                                .addClass(`${changIcon}`);
                        }
                    } else {
                        parent.wex[typebar][typepage[typebar].Json][
                            IndexKey
                        ].is_homepage = 1;

                        parent.wex[typebar][typepage[typebar].Json][
                            IndexKey
                        ].type = 'home-normal';

                        if (isData.slug_id == parent.currentSlugID) {
                            const classIcon = parent
                                .$('#CurrenttypeIcon')
                                .attr('class')
                                .match(/icon\-visibility\s(.*)/)[1];

                            visibilityIcon =
                                visibilityIcon == 'restricted'
                                    ? 'specific'
                                    : visibilityIcon;

                            visibilityIcon =
                                visibilityIcon == 'internal-member'
                                    ? 'member'
                                    : visibilityIcon;

                            const changIcon =
                                parent.wex.iconvisibility.home[visibilityIcon];

                            parent
                                .$('#CurrenttypeIcon')
                                .removeClass(`${classIcon}`)
                                .addClass(`${changIcon}`);
                        }
                    }
                });

                break;

            case 'deletePage':
                var fb = $('#frameBody').get(0).contentWindow;
                var isParent =
                    parent.wex[typebar][typepage[typebar].Json][IndexKey]
                        .parent;

                parent.wex[typebar][typepage[typebar].Json].splice(IndexKey, 1);
                parent.wex[typebar][typepage[typebar].recently].splice(
                    indexRecent,
                    1
                );

                if (fb.$(`#selected_navigator [slug-id="${isData.slug_id}"]`)) {
                    fb.$(
                        `#selected_navigator [slug-id="${isData.slug_id}"]`
                    ).remove();
                }

                if (typebar == 'blog') {
                    var lengthPost = $.grep(
                        parent.wex[typebar][typepage[typebar].Json],
                        function (k, v) {
                            return k.parent == isParent;
                        }
                    ).length;

                    if (!lengthPost) {
                        $.grep(
                            parent.wex[typebar][typepage[typebar].jsonCat],
                            function (k, v) {
                                if (k.id == isParent) {
                                    k.haveChild = false;
                                }
                            }
                        );
                    }
                }

                parent.$('#' + isEleRecent).jstree(true).settings.core.data =
                    parent.wex[typebar][typepage[typebar].recently];

                parent
                    .$('#' + isEleRecent)
                    .jstree(true)
                    .refresh();

                break;
            case 'Duplicate':
                var setdata = {};
                $.each(isData, function (k, v) {
                    setdata[k] = v;
                });

                if (typebar == 'page') {
                    parent.wex[typebar].page_internal.push(setdata);
                    RVwys.rigthbar.isJstree.refresh(
                        $('#listpage_internal'),
                        parent.wex[typebar].page_internal,
                        typebar
                    );
                } else {
                    parent.wex[typebar][typepage[typebar].Json].push(setdata);
                }
                parent.$('.overlaypanel').remove();
                if (parent.wex.page.page_internal.length != 0) {
                    $('.listtitle_internal').show();
                }

                break;
            case 'rename':
                // update wex
                parent.wex[typebar][typepage[typebar].Json][
                    IndexKey
                ].slug_name = isData.slug_name;
                parent.wex[typebar][typepage[typebar].Json][
                    IndexKey
                ].page_name = isData.page_name;
                parent.wex[typebar][typepage[typebar].Json][IndexKey].text =
                    isData.page_name;

                if (indexRecent >= 0) {
                    parent.wex[typebar][typepage[typebar].recently][
                        indexRecent
                    ].text = isData.page_name;
                    parent
                        .$('#' + isEleRecent)
                        .jstree(true).settings.core.data =
                        parent.wex[typebar][typepage[typebar].recently];
                }

                parent.$('#' + isEleRecent).jstree('refresh');

                if (isData.slug_id == parent.currentSlugID) {
                    parent.$('#cmsCurrent').text(isData.slug_name);
                    window.history.pushState('data', 'Title', isData.url);
                }

                if (isData.changed_menutitle) {
                    RVwys.rigthbar.isJstree.updatemenu(beforeSlug, isData);
                }

                break;
            default:
                // Final else

                break;
        }

        $('.rvsb-design-property').hide();

        var isData;
        switch (typebar) {
            case 'blog':
            case 'post':
                var connect = parent.wex[typebar][
                    typepage[typebar].Json
                ].concat(parent.wex.blog.blog_listscategory);
                isData = connect;
                RVwys.rigthbar.isJstree.refresh(
                    parent.$('#' + isType),
                    connect,
                    typebar
                );

                break;

            case 'page':
                isData = parent.wex[typebar]['page_tree'];
                RVwys.rigthbar.isJstree.refresh(
                    parent.$('#listpage_onmenu'),
                    isData,
                    typebar
                );

                break;

            default:
                isData = parent.wex[typebar][typepage[typebar].Json];
                RVwys.rigthbar.isJstree.refresh(
                    parent.$('#' + isType),
                    isData,
                    typebar
                );
                break;
        }

        BuildAttrIsJstreeSetJstree(typebar, isData);
    };

    RVwys.rigthbar.isJstree.createJSTrees = function (
        element,
        dataFromWex,
        typeAll
    ) {
        const { type, iconType } = typeAll;
        const newIconType = {
            ...customIconJStree.JStreeTypeIconHome(),
            ...iconType,
        };

        element.prev().find('span').text(dataFromWex.length);
        BuildAttrIsJstreeSetJstree(type, dataFromWex);

        // RVwys.rigthbar.isJstree[type].SetJstree(element,data);
        // RVwys.rigthbar.isJstree.refresh(element,data,type);

        element.jstree({
            core: {
                worker: true,
                data: dataFromWex,
            },
            types: newIconType,
            search: {
                case_insensitive: true,
                show_only_matches: true,
                // 'search_leaves_only':true
            },
            plugins: ['types', 'search', 'massload'],
        });

        element.on('ready.jstree', function (event, data) {
            console.log('ready.jstree');
        });

        element.on('hover_node.jstree', function (e, data) {
            $(this).find('.icon-control').remove();
            var thisNode = $(this).find(`[id="${data.node.id}"]`);
            var nodeData = data.node;

            if (
                RVwys.rigthbar.isJstree?.[type] &&
                !nodeData.type.match('system')
            ) {
                RVwys.rigthbar.isJstree[type]?.CreateOption?.(
                    thisNode,
                    nodeData
                );
            }
        });

        element.on('dehover_node.jstree', function () {
            console.log('dehover_node.jstree');
        });

        element.on('open_node.jstree', function () {
            console.log('open_node.jstree');
        });

        element.on('select_node.jstree', function (e, data) {
            var href = data.node.a_attr.href;
            parent.window.location.href = href;
        });

        element
            .on('search.jstree', function (nodes, str) {
                if (str.nodes.length === 0) {
                    // element.jstree(true).hide_all();
                }
            })
            .on('clear_search.jstree', function (e) {
                // element.jstree(true).show_all();
            });
    };

    RVwys.rigthbar.isJstree.page.CreateOption = function (thisNode, nodeData) {
        console.log('nodeData: ', nodeData);

        if (!thisNode.is('[page-type="externalmenu"]')) {
            var iconOption = $(
                `<button class="icon-control">
                    <i class="uk-icon-small uk-icon-ellipsis-v editPage pull-right ${nodeData.id}" ></i>
                </button>`
            );

            if (thisNode.find('ul').length > 0) {
                iconOption.insertBefore(thisNode.find('ul').first());
            } else {
                thisNode.append(iconOption);
            }

            iconOption.click(function (e) {
                var type = $(this)
                    .closest('.dd')
                    .attr('id')
                    .match(/^sortable-(.*)/)[1];
                var oThis = $(this).closest('li');
                parent.activePageID = oThis.attr('page-id');
                parent.activePageName = oThis.attr('page-name');
                parent.activeSlug = oThis.attr('slug-name');
                window.activeSlugID = oThis.attr('slug-id');
                window.activePageType = type;
                parent.activeType = oThis.attr('page-type');

                parent.activeId = oThis.attr('id');
                parent.eleActive = $(e.target).closest('div')[0].id;

                console.log('parent.activePageType : ' + window.activePageType);
                RVwys.rigthbar.isJstree.Eventjstree(oThis);
            });
        }
    };

    RVwys.rigthbar.isJstree.blog.CreateOption = function (thisNode, nodeData) {
        var iconOptionPost = $(`<button class="icon-control">
        <i class="uk-icon-small uk-icon-ellipsis-v editPage pull-right ${nodeData.id}"></i>
        </button>`);

        var iconOptionCategory = $(`<button class="icon-control">
        <i class="uk-icon-small uk-icon-ellipsis-v editCate pull-right ${nodeData.id}"></i>
        </button>`);

        var defaultฺBlogID = parent.wex.blog.blog_listscategory[0].id;
        console.log('defaultฺBlogID: ', defaultฺBlogID);
        console.log('nodeData: ', nodeData);
        console.log('thisNode: ', thisNode);

        if (thisNode.hasClass('blog_cate')) {
            if (thisNode.find('ul').length > 0) {
                iconOptionCategory.insertBefore(thisNode.find('ul').first());
            } else {
                thisNode.prepend(iconOptionCategory);
            }
        } else {
            thisNode.prepend(iconOptionPost);
        }

        iconOptionPost.click(function (e) {
            console.log('%c Click Post', 'background-color:yellow');

            var oThis = $(this).closest('li');

            window.activePageType = 'blog';
            parent.activePageID = oThis.attr('post-id');
            parent.activePageName = oThis.attr('post-name');
            parent.activeSlug = oThis.attr('slug-name');
            window.activeSlugID = oThis.attr('slug-id');
            parent.activeType = oThis.attr('post-type');

            parent.activeId = oThis.attr('id');
            parent.eleActive = $(e.target).closest('div')[0].id;
            RVwys.rigthbar.isJstree.Eventjstree(oThis);

            // console.log('type '+parent.activePageType);
        });

        iconOptionCategory.click(function (e) {
            console.log('Click Category');
            var oThis = $(this).closest('li');
            var Id = oThis.attr('category-id').match(/^category(.*)/)
                ? oThis.attr('category-id').match(/^category(.*)/)[1]
                : oThis.attr('category-id');
            window.activePageType = 'blog';
            window.activeBlogId = Id;
            window.activeBlogname = oThis.attr('category-text');
            parent.activeSlug = oThis.attr('slug-name');
            window.activeIndexKey = oThis.attr('indexkey');
            window.activeSlugID = oThis.attr('slug-id');
            parent.eleActive = $(e.target).closest('div')[0].id;
            window.blogindex = activeIndexKey == '0' ? true : false;

            RVwys.rigthbar.isJstree.EventBlog(oThis);
        });
    };

    RVwys.rigthbar.isJstree.refresh = function (element, jsonData) {
        console.log('jsonData: ', jsonData);
        console.log('element: ', element);
        if (element.jstree(true).settings?.core?.data) {
            element.jstree(true).settings.core.data = jsonData;
            element.jstree(true).refresh();
        }
    };

    RVwys.rigthbar.isJstree.updatemenu = function (oldslug, data) {
        var ele =
            $(
                `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
            ).length > 0
                ? $(
                      `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
                  )
                : $('#frameBody')
                      .get(0)
                      .contentWindow.$(
                          `#selected_navigator li[menu-slug='${oldslug}'][slug-id='${data.slug_id}']`
                      );

        var NavIcon = $(ele.find('span i')[0]).prop('outerHTML');
        var downIcon =
            ele.find('span .uk-icon-caret-down').length > 0
                ? $(ele.find('span .uk-icon-caret-down')[0]).prop('outerHTML')
                : '';

        ele.children('a')
            .children('span')
            .html(NavIcon + ' ' + data.page_name + downIcon);
        ele.attr('menu-slug', data.slug_name);
        ele.attr('menu-title', data.page_name);
        ele.attr('url', data.url);
    };

    RVwys.rigthbar.isJstree.PostCatagories = function () {
        $('#Countcategory').text(parent.wex.blog.blog_categories.length);

        var UI = parent.UIkit;

        var options = {
            bgclose: false,
            keyboard: false,
            modal: false,
        };

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>' +
                    rvLang('Blog Catagory') +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin uk-modal-content uk-overflow-container"><div>' +
                    $('#omodalBlog').html() +
                    '</div></div>',
                '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                    rvLang('Save') +
                    '</button>',
                '<button class="uk-button js-modal-confirm-cancel">' +
                    rvLang('Cancel') +
                    '</button></div>',
            ].join(''),
            options
        );
        modal.element.find('.uk-button-success').on('click', function () {
            onInsert();
        });

        modal.element.find('.js-modal-confirm-cancel').on('click', function () {
            oncancel();
        });

        modal.show();

        var element = modal.element.find('#sortcat');

        $.each(parent.wex.blog.blog_categories, function (k, v) {
            parent.wex.blog.blog_categories[k]['state'] = {
                opened: true,
            };
        });

        element
            .jstree({
                core: {
                    data: parent.wex.blog.blog_categories,
                    check_callback: function (
                        operation,
                        node,
                        node_parent,
                        node_position,
                        more
                    ) {
                        return true;
                    },
                },
                types: {
                    default: {
                        icon: 'uk-icon-folder-open-o',
                        max_depth: 3,
                    },
                },
                plugins: ['dnd', 'types'],
            })
            .on('loaded.jstree', function (event, data) {});

        oncancel = function () {
            modal.hide();
        };

        var onInsert = function () {
            var jstreeCat = element.jstree(true).get_json('#', {
                flat: true,
            });
            var obj = {};
            var arrBlog = [];

            $.each(jstreeCat, function (key, data) {
                var parent_id =
                    data.parent == '#' ? '0' : data.parent.match(/[0-9]/)[0];
                var matchId = data.id.match(/[0-9]/);
                var id = parseInt(matchId);
                obj = {
                    id: id,
                    parent_id: parent_id,
                    category_name: data.text,
                };
                arrBlog.push(obj);

                // Update wex.blog.blog_listscategory
                var indexCat = $.map(
                    parent.wex.blog.blog_categories,
                    function (obj, index) {
                        return obj.id;
                    }
                ).indexOf(data.id);

                parent.wex.blog.blog_categories[indexCat].parent = data.parent;
            });

            $.ajax({
                type: 'GET',
                url: '/admin/category/category/ajaxeditcategory',
                data: {
                    arrblog: arrBlog,
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                error: function () {
                    // callback("error", null);
                },
                success: function (data) {
                    parent.console.pop[data.status]({
                        text: data.status,
                        delay: 2000,
                    });

                    modal.hide();
                },
            });
        };
    };

    RVwys.rigthbar.isJstree.EventBlog = function (oThis) {
        var isBlogIndex = oThis.attr('indexkey') == '0';
        var ischild = oThis.attr('is-child');
        // Specifically blogindex

        var isPublic = oThis.attr('is-published') == 1;
        var isHome = oThis.attr('is-homepage') == 'true';
        console.log('oThis: ', oThis);
        console.log('isHome: ', isHome);
        var parentPublic =
            oThis.parent().closest('li').attr('is-published') == 1;

        parent.$('#blog_setHomePage').toggle(!isHome);

        parent.$('#blog_setHide').toggle(isPublic);
        parent.$('#blog_unsetHide').toggle(!isPublic);
        // }

        parent.$('#blog_delete').toggle(!isBlogIndex);
        // End Specifically blogindex
        $('.rename-title#category-name').toggle(!isBlogIndex);
        $('.rename-title#blogIndex-name').toggle(isBlogIndex);

        ischild == 'true'
            ? parent.$('#blog_delete').addClass('disable-delete')
            : parent.$('#blog_delete').removeClass('disable-delete');

        parent.$('.rvsb-design-property').hide();
        parent.$('#blog_title').text(window.activeBlogname);
        parent.$('.blogSetting').show();

        var positionsetting = oThis.position();

        var Maxh = screen.height - positionsetting.top;
        if (Maxh < 350) {
            parent.$('.blogSetting').css({
                right: '200px',
                top: '410',
            });
        } else {
            parent.$('.blogSetting').css({
                right: '200px',
                top: positionsetting.top - 5,
            });
        }
    };

    RVwys.rigthbar.isJstree.Recently = function () {
        $.each(parent.wex.page.page_recently, function (k, v) {
            parent.wex.page.page_recently[k]['type'] = 'default';
            parent.wex.page.page_recently[k]['li_attr'] = {
                'value-post': v.text,
            };
            parent.wex.page.page_recently[k]['a_attr'] = {
                href: parent.wex.url.WYS_SHOW_URL + '/' + v.slug_name,
            };
        });
        var _selectedNodeId;

        parent.$('#RecentPage').jstree({
            core: {
                data: parent.wex.page.page_recently,
            },
            types: {
                default: {
                    icon: 'icon-visibility parent-normal',
                },
            },
            plugins: ['types', 'wholerow', 'changed'],
        });

        parent.$('#RecentPage').bind('select_node.jstree', function (e, data) {
            var href = data.node.a_attr.href;
            parent.window.location.href = href;
            /*	 var val = data.node.li_attr["value-post"];
		 if ( _selectedNodeId === data.node.id ) {
		        data.instance.deselect_node(data.node);
		        _selectedNodeId = "";
		        val = '';
		    } else {
		        _selectedNodeId = data.node.id;
		    }

		$('#listpage_onmenu,#listpage_internal').jstree('search',val);*/
        });
    };

    RVwys.rigthbar.isJstree.CallbackoptionBlog = function (data, typeoption) {
        console.log('RVwys.rigthbar.isJstree.CallbackoptionBlog');

        var currentSlugID = data.slug_id;
        var indexBlog = RVwys.rigthbar.isJstree.findIndexKey(
            wex.blog.blog_listscategory,
            'slug_id',
            +currentSlugID
        );

        console.log(currentSlugID);
        console.log(indexBlog);

        switch (typeoption) {
            case 'sethome':
                // Update wex.blog.blog_lists after set blog index to Homepage
                var indexBlogHome = RVwys.rigthbar.isJstree.findIndexKey(
                    wex.blog.blog_lists,
                    'is_homepage',
                    1
                );

                if (indexBlogHome >= 0) {
                    wex.blog.blog_lists[indexBlogHome].is_homepage = 0;
                    wex.blog.blog_lists[indexBlogHome].type = 'default';
                    wex.blog.blog_lists[indexBlogHome].statusIcon =
                        'bpost-normal';
                }

                // Update wex.page.page_tree after set blog index to Homepage
                if (wex.page.page_tree.length > 0) {
                    var indexPageOnMenu = RVwys.rigthbar.isJstree.findIndexKey(
                        wex.page.page_tree,
                        'is_homepage',
                        1
                    );

                    if (indexPageOnMenu >= 0) {
                        wex.page.page_tree[indexPageOnMenu].is_homepage = 0;
                        wex.page.page_tree[indexPageOnMenu].type = 'default';
                        wex.page.page_tree[indexPageOnMenu].statusIcon =
                            'parent-normal';
                    }
                }

                // Update wex.blog.blog_listscategory set blog index
                if (indexBlog >= 0) {
                    wex.blog.blog_listscategory[indexBlog].is_homepage = 1;
                    wex.blog.blog_listscategory[indexBlog].statusIcon =
                        'home-normal';
                }

                RVwys.rigthbar.isJstree.refreshBlog();

                break;

            case 'sethide':
                // statusIcon: "bpost-normal-draft", type: "hide"
                var type = 'hide';

                RVwys.rigthbar.isJstree.setHideAndUnhide(
                    currentSlugID,
                    indexBlog,
                    typeoption,
                    type
                );
                wex.blog.blog_listscategory[indexBlog].is_published = 0;

                RVwys.rigthbar.isJstree.refreshBlog();

                break;

            case 'unsethide':
                // statusIcon: "bpost-normal"  type:"default"
                type = 'default';

                RVwys.rigthbar.isJstree.setHideAndUnhide(
                    currentSlugID,
                    indexBlog,
                    typeoption,
                    type
                );
                wex.blog.blog_listscategory[indexBlog].is_published = 1;

                var listblog = [
                    ...wex.blog.blog_lists,
                    ...wex.blog.blog_listscategory,
                ];

                RVwys.rigthbar.isJstree.refreshBlog();
                break;

            default:
                // refresh jstree

                break;
        }

        $('.blogSetting').hide();
    };

    RVwys.rigthbar.isJstree.refreshBlog = function () {
        var listblog = [...wex.blog.blog_lists, ...wex.blog.blog_listscategory];
        RVwys.rigthbar.isJstree.refresh($('#listblog'), listblog, 'blog');
    };

    RVwys.rigthbar.isJstree.findIndexKey = function (
        listData,
        keyword,
        keywordMap
    ) {
        return $.map(listData, function (obj) {
            return obj[keyword];
        }).indexOf(keywordMap);
    };

    RVwys.rigthbar.isJstree.setHideAndUnhide = function (
        slugid,
        indexBlog,
        status,
        type
    ) {
        console.log('RVwys.rigthbar.isJstree.setHideAndUnhide');

        var blog = {
            post: 'blog_lists',
            category: 'blog_listscategory',
        };

        var iconCate = status == 'sethide' ? 'hidecategory' : 'category';
        var typeoption = status == 'sethide' ? 0 : 1;
        $.each(blog, function (indexInBlog, valueOfBlog) {
            type = indexInBlog == 'post' ? type : iconCate;
            if (window.blogindex) {
                $.each(
                    wex.blog[valueOfBlog],
                    function (indexInArray, valueOfElement) {
                        if (valueOfElement.slug_id != slugid) {
                            valueOfElement.type = type;
                        }
                    }
                );

                wex.blog.blog_listscategory[indexBlog].type = type;
            } else {
                var slug_name =
                    wex.blog.blog_listscategory[indexBlog].slug_name;
                $.each(
                    wex.blog[valueOfBlog],
                    function (indexInArray, valueOfElement) {
                        if (valueOfElement.category_slug_name == slug_name) {
                            valueOfElement.type = type;
                            valueOfElement.is_published = typeoption;
                        }
                    }
                );
                wex.blog.blog_listscategory[indexBlog].type = type;
            }
        });
    };

    RVwys.designViewAddEvent('mousedown', function (e) {
        // parent.$('.rvsb-design-property').hide();
        // parent.$('.rvsb-design-bar-right').addClass()
    });
})(jQuery);
